import type { PipelineStage } from '@/types/pipeline';
import { requiresPipelineWorkflowOverride } from './jobPipeline';

export interface PipelineWorkflowOverridePayload {
  workflowOverride?: true;
  workflowOverrideReason?: string;
}

export function requestPipelineWorkflowOverride({
  stages,
  currentStageId,
  targetStageId,
  pausedFromStageId,
}: {
  stages: PipelineStage[];
  currentStageId?: string | null;
  targetStageId?: string | null;
  pausedFromStageId?: string | null;
}): PipelineWorkflowOverridePayload | null {
  if (
    !requiresPipelineWorkflowOverride({
      stages,
      currentStageId,
      targetStageId,
      pausedFromStageId,
    })
  ) {
    return {};
  }

  const currentStage = stages.find((stage) => stage.id === currentStageId);
  const targetStage = stages.find((stage) => stage.id === targetStageId);
  const reason = window
    .prompt(
      `Reason for workflow override from ${currentStage?.name ?? 'current stage'} to ${
        targetStage?.name ?? 'selected stage'
      }:`,
    )
    ?.trim();

  if (!reason) return null;
  return { workflowOverride: true, workflowOverrideReason: reason };
}
